<script>
import CrmBottomNavigation, {
  CRM_BOTTOM_NAV_ROUTES
} from "@/components/crm/CrmBottomNavigation.vue";
import LacosteBottomNavigation, {
  LACOSTE_BOTTOM_NAV_ROUTES
} from "@/components/crm/LacosteBottomNavigation.vue";
import StandardV2Header from "@/views/layout/StandardV2Header.vue";

export default {
  name: "StandardV2Layout",
  components: {
    CrmBottomNavigation,
    LacosteBottomNavigation,
    StandardV2Header
  },
  inject: {
    isInsideStandardV2Layout: {
      default: false
    }
  },
  provide() {
    return {
      isInsideStandardV2Layout: true
    };
  },
  computed: {
    normalizedRoutePath() {
      const path = this.$route.path || "";
      if (path.length > 1 && path.endsWith("/")) return path.slice(0, -1);
      return path;
    },
    showBottomNavigation() {
      const routes = this.$isLacoste
        ? LACOSTE_BOTTOM_NAV_ROUTES
        : CRM_BOTTOM_NAV_ROUTES;
      return routes.includes(this.normalizedRoutePath);
    },
    headerConfig() {
      return this.$route.meta?.standardV2Header || null;
    }
  },
  methods: {
    resolveHeaderTitle(headerConfig) {
      if (!headerConfig) return "";
      if (headerConfig.titleKey) return this.$t(headerConfig.titleKey);
      return headerConfig.title || "";
    },
    handleHeaderAction(action) {
      if (action.key === "back") {
        this.$router.back();
        return;
      }

      if (action.to) {
        this.$router.push(action.to);
        return;
      }

      this.emitter.emit("standard-v2-header-action", {
        action: action.key,
        route: this.$route.name
      });
    }
  }
};
</script>

<template>
  <slot v-if="isInsideStandardV2Layout" />
  <main v-else class="standard-v2-layout" data-test="standard-v2-layout">
    <StandardV2Header
      v-if="headerConfig"
      :title="resolveHeaderTitle(headerConfig)"
      :show-back="headerConfig.showBack"
      :compact-back="headerConfig.compactBack"
      :actions="headerConfig.actions"
      @action="handleHeaderAction"
    />
    <div
      :class="[
        'standard-v2-layout__content',
        {
          'standard-v2-layout__content--with-header': headerConfig,
          'standard-v2-layout__content--with-bottom-navigation':
            showBottomNavigation
        }
      ]"
      data-test="standard-v2-content"
    >
      <slot />
    </div>
    <LacosteBottomNavigation v-if="showBottomNavigation && $isLacoste" />
    <CrmBottomNavigation v-else-if="showBottomNavigation" />
  </main>
</template>

<style lang="scss" scoped>
.standard-v2-layout {
  // min-height: 100dvh;
  // background: #f7f7f7;
}

.standard-v2-layout__content {
  min-height: 100vh;
}

.standard-v2-layout__content--with-header {
  min-height: calc(100vh - 70px);
}

.standard-v2-layout__content--with-bottom-navigation {
  min-height: calc(100vh - 96px);
  padding-bottom: calc(96px + env(safe-area-inset-bottom));
}
</style>
